import React from 'react';
import loadable from '@loadable/component';
import PropTypes from 'prop-types';
import Loading from 'Components/Loading';
import ApplicationLayout from 'Components/ApplicationLayout';
import pMinDelay from 'p-min-delay';

const PauseMembership = loadable(() => pMinDelay(import('./PauseMembership'), 300), {
  fallback: <Loading />
});

const AsyncPauseMembership = props => {
  const pageConfig = {
    headerType: 'mobile-none',
    footerType: 'none',
    helmet: {
      bodyAttributes: {
        class: `${ props.userAgent.device?.type } hide-betslip hide-sticky-navigation bg-solid-gray`
      }
    }
  };

  return (
    <ApplicationLayout { ...pageConfig } { ...props }>
      <PauseMembership { ...props }/>
    </ApplicationLayout>
  );
};

AsyncPauseMembership.propTypes = {
  userAgent: PropTypes.object,
  history: PropTypes.object,
  match: PropTypes.object,
};

export default AsyncPauseMembership;
